<template>
  <component
    :is="tagName"
    v-bind="attrs"
    :type="type"
    :class="{
      loading: isLoading,
      'sf-button--disabled': disabled || isLoading,
    }"
    class="sf-button sf-ripple"
    @click="onClick">
    <sf-loading v-if="isLoading" overlay/>
    <div class="sf-button__content">
      <!-- Left icon slot -->
      <div v-if="$slots.left" class="sf-button__left">
        <slot name="left"/>
      </div>

      <!-- Inner content -->
      <div class="sf-button__inner">
        <slot/>
      </div>

      <!-- Right icon slot -->
      <div v-if="$slots.right" class="sf-button__right">
        <slot name="right"/>
      </div>
    </div>
  </component>
</template>

<script>
export default {
  props: {
    /* Button is disabled and has loading attached */
    loading: {
      type: Boolean,
      default: false,
    },

    /* Button is simply disabled */
    disabled: {
      type: Boolean,
      default: false,
    },

    /* Button type */
    type: {
      type: String,
      default: 'button',
    },

    /* Button url */
    url: {
      type: String,
      default: '',
    },

    /* Target for url */
    target: {
      type: String,
      default: '_self',
    },

    /* Button name for behaviour capture */
    name: {
      type: String,
      default: 'button',
    },
  },
  inject: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    behaviourCapture: {
      eventStart: null,
      eventEnd: null,
    },
  }),
  computed: {
    attrs() {
      if (this.url) {
        const { url, target } = this;

        if (target === '_self') {
          return { to: url };
        }

        return { href: url, target };
      }

      return {};
    },
    tagName() {
      if (this.url) {
        return this.target === '_self' ? 'nuxt-link' : 'a';
      }

      return 'button';
    },
    isLoading() {
      return this.form.loading || this.loading;
    },
    behaviour() {
      const { eventStart, eventEnd } = this.behaviourCapture;
      return {
        eventStart,
        eventEnd,
        duration: eventEnd - eventStart,
      };
    },
  },
  methods: {
    /** Emit click event only when
     *  - Button is not disabled
     *  - Button is not in loading state
     */
    onClick() {
      if (!this.isLoading && !this.disabled) {
        this.$emit('click');
        this.behaviourCapture.eventEnd = Date.now();
        if (this.behaviourCapture.eventStart === null) {
          this.behaviourCapture.eventStart = Date.now();
        }
      }
    },
  },
};
</script>
